import { render, staticRenderFns } from "./TaskDialogBox.vue?vue&type=template&id=3c88dee0&scoped=true"
import script from "./TaskDialogBox.vue?vue&type=script&lang=js"
export * from "./TaskDialogBox.vue?vue&type=script&lang=js"
import style0 from "./TaskDialogBox.vue?vue&type=style&index=0&id=3c88dee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c88dee0",
  null
  
)

export default component.exports